import React from "react";
import { SidebarContainer, Logo } from "./styles";
import SaudeLogo from "../../Assets/LogoNovi.png";

export default function Sidebar() {
	// const history = useHistory();
	// const { token } = useAuth();

	// useEffect(() => {
	// 	if (token) {
	// 		history.push("/perfil");
	// 	}
	// }, [token, history]);

	return (
		<SidebarContainer>
			<Logo src={SaudeLogo} />
		</SidebarContainer>
	);
}
